<div class="app-container">
  <toolbar></toolbar>
  <progress-bar></progress-bar>
  <banner></banner>
  <div class="app-contents">
    <indoor-map-view></indoor-map-view>
  </div>
</div>
